import { CButton, CInputGroup, CInputGroupAppend, CInputGroupPrepend } from '@coreui/react';
import * as React from 'react';
import { IImageProvider } from '../abstraction';

interface IProps {
    type: "append" | "prepend",
    text: string,
    image: string,
    imageProvider: IImageProvider,		                      // Interface vers fournisseur d'image impl�mentant getImg
    onClick?: (any) => void,
    visibilityCondition: string
}

export class KControlAddon extends React.Component<IProps> {
    public constructor(props: any) {
        super(props);
    }

    // En cas de clic, on transmet au proprio
    onClick = (event) => {
        if (this.props.onClick) { this.props.onClick(event); }
    }

    render() {
        var visible = true;
        if (this.props.visibilityCondition) {
            try { visible = eval(this.props.visibilityCondition) }
            catch (err) { }
        }

        if (visible) {
            if (this.props.image) {
                if (this.props.type == "append") {
                    return <CInputGroupAppend onClick={this.onClick}>
                        <img src={this.props.imageProvider.getImg(this.props.image)} />
                    </CInputGroupAppend >
                }
                else {
                    return <CInputGroupPrepend onClick={this.onClick}>
                        <img src={this.props.imageProvider.getImg(this.props.image)} />
                    </CInputGroupPrepend>
                }
            }

            if (this.props.text) {
                if (this.props.type == "append") {
                    return <CInputGroupAppend>
                        <CButton color="secondary" onClick={this.onClick}>{this.props.text}</CButton>
                    </CInputGroupAppend>
                }
                else {
                    return <CInputGroupPrepend>
                        <CButton color="secondary" onClick={this.onClick}>{this.props.text}</CButton>
                    </CInputGroupPrepend>
                }
            }
        }
        return "";
    }
}
